import React, { useEffect } from 'react';
import { useGlobalContext } from "../context/GlobalContext";
import { VisualId } from '../modals/VisualId';
import { Posters } from "../modals/Posters";
import { Logo } from "../modals/Logo";
import { Typo } from "../modals/Typo";
import { Rdambook } from "../modals/Rdambook";


export const GraphicDesign = (props) => {
  const { setLightTheme, setChild, child, setNested } = useGlobalContext()

  useEffect(() => {
    setLightTheme(true);
  }, [])

  function toggleNested() {
    setChild('');
    setNested(false);
  }


  const blocks = !child ? (
    <div className="b-graphics__wrap">
      <div className="b-graphics__container"
        onClick={() => setChild('posters')}>
        <img className="lazyload b-graphics__cover" src={require('../static/images/graphics/posters.png')} alt="posters" />
        <div className="b-graphics__cover title">POSTERS</div>
      </div>
      <div className="b-graphics__container"
        onClick={() => setChild('book')}>
        <img className="lazyload b-graphics__cover" src={require('../static/images/graphics/010/010cover.png')} alt="010 book" />
        <div className="b-graphics__cover title">BOOK DESIGN</div>
      </div>
      <div className="b-graphics__container"
        onClick={() => setChild('vid')}>
        <img className="lazyload b-graphics__cover" src={require('../static/images/menu_covers/vi_cover.png')} alt="visual id" />
        <div className="b-graphics__cover title">VISUAL IDENTITY</div>
      </div>
      <div className="b-graphics__container"
        onClick={() => setChild('logo')}>
        <img className="lazyload b-graphics__cover" src={require('../static/images/graphics/logo_mupop.png')} alt="logo design" />
        <div className="b-graphics__cover title">LOGO DESIGN</div>
      </div>
      <div className="b-graphics__container"
        onClick={() => setChild('typo')}>
        <img className="lazyload b-graphics__cover" src={require('../static/images/graphics/typo.png')} alt="typography" />
        <div className="b-graphics__cover title">TYPOGRAPHY</div>
      </div>
    </div>
  ) : null

  return (
    <div className="b-graphics l-container">
      {child && <button className="b-graphics__button" onClick={() => toggleNested()}>
        <div className="b-graphics__button-icon" />
        BACK
      </button>}
      {child === 'vid' && <VisualId />}
      {child === 'posters' && <Posters />}
      {child === 'logo' && <Logo />}
      {child === 'typo' && <Typo />}
      {child === 'book' && <Rdambook />}
      {blocks}
    </div>
  )
}